// extracted by mini-css-extract-plugin
export default {"placeholder":"CommunityAutomationsRecordLoader_placeholder__-Pctv"};